/* KIMAIA Homepage Bundle Popup
   ─────────────────────────────────────────────────────────────
   Replaces the redirect-to-PDP behavior on the 2 homepage bundle
   cards (Daily Glow Kit + Glow & Balance Kit) with a smaak-picker
   popup. Add-to-cart goes to a single bundle variant ID with line
   item properties — Simple Bundles & Kits app expands the bundle
   on the server side.

   Trigger detection:
     - .kgk__cta  → Daily Glow Kit
     - .gbk__cta  → Glow & Balance Kit
     - Anything with [data-kimaia-bundle-popup-config]
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var ROOT_ID  = 'kimaiaBundlePopup';
  var STYLE_ID = 'kimaiaBundlePopupStyles';

  /* ── Hardcoded bundle configs for the 2 homepage cards ── */
  var OCEAN_VALUES  = ['Mango', 'Strawberry', 'Watermelon', 'Pineapple', 'Lemon mint', 'Neutral'];
  var VALLEY_VALUES = ['Mango', 'Pineapple', 'Orange', 'Grapefruit', 'Lemon mint', 'Neutral'];

  var HOMEPAGE_BUNDLES = [
    {
      selector: '.kgk__cta',
      cfg: {
        variantId: '54016950501716',
        eyebrow: 'BESTSELLER',
        title: 'Stel jouw Daily Glow Kit samen',
        sub: 'Kies jouw favoriete smaken voor de complete dagelijkse routine.',
        ctaText: 'Voeg Daily Glow Kit toe',
        guarantee: '30 dagen niet goed? Geld terug.',
        groups: [
          { property: 'Kies jouw Ocean Glow smaak',  label: 'Kies jouw Ocean Glow smaak',  values: OCEAN_VALUES  },
          { property: 'Kies jouw Valley Glow smaak', label: 'Kies jouw Valley Glow smaak', values: VALLEY_VALUES }
        ],
        autoProperties: {
          'Inclusief KIMAIA Water Bottle': 'KIMAIA Water Bottle'
        }
      }
    },
    {
      selector: '.gbk__cta',
      cfg: {
        variantId: '54016880771412',
        eyebrow: 'MAXIMAAL RESULTAAT',
        title: 'Stel jouw Glow & Balance Kit samen',
        sub: 'De complete dagelijkse routine — kies jouw favoriete smaken.',
        ctaText: 'Voeg Glow & Balance Kit toe',
        guarantee: '30 dagen niet goed? Geld terug.',
        groups: [
          { property: 'Kies jouw Ocean Glow smaak',  label: 'Kies jouw Ocean Glow smaak',  values: OCEAN_VALUES  },
          { property: 'Kies jouw Valley Glow smaak', label: 'Kies jouw Valley Glow smaak', values: VALLEY_VALUES }
        ],
        autoProperties: {
          'Inclusief KIMAIA Algae Omega':  'KIMAIA Algae Omega',
          'Inclusief KIMAIA Water Bottle': 'KIMAIA Water Bottle'
        }
      }
    }
  ];

  /* ── Styles (overlay + hide inline pickers) ── */
  var STYLES = [
    /* Hide inline pickers on the homepage bundle cards — popup is the source of truth */
    '.kgk__block--flavors,.gbk__block--flavors{display:none !important;}',

    /* Popup overlay */
    '.kbp{display:none;position:fixed;inset:0;z-index:9999;}',
    '.kbp.is-open{display:flex;align-items:center;justify-content:center;padding:20px;}',
    'body.kbp-open{overflow:hidden;}',
    '.kbp__overlay{position:absolute;inset:0;background:rgba(10,8,4,.78);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);}',
    '.kbp__panel{position:relative;z-index:1;width:100%;max-width:460px;background:linear-gradient(145deg,#1c1a17 0%,#2a2520 50%,#3a3028 100%);border-radius:20px;box-shadow:0 32px 80px rgba(0,0,0,.6),0 0 0 1px rgba(180,148,60,.18);max-height:90vh;overflow-y:auto;animation:kbpIn .26s ease;}',
    '@keyframes kbpIn{from{opacity:0;transform:translateY(8px) scale(.985);}to{opacity:1;transform:none;}}',
    '.kbp__close{position:absolute;top:12px;right:12px;width:32px;height:32px;border-radius:999px;background:rgba(255,245,220,.06);color:rgba(235,218,185,.85);border:1px solid rgba(255,245,220,.10);font-size:22px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:2;}',
    '.kbp__close:hover{background:rgba(255,245,220,.12);color:#fff;}',
    '.kbp__inner{padding:32px 24px 22px;}',
    '.kbp__head{text-align:center;margin-bottom:22px;}',
    '.kbp__eyebrow{display:inline-block;font-family:var(--nino-sans,"Inter",sans-serif);font-size:9.5px;font-weight:500;letter-spacing:5.5px;text-transform:uppercase;color:#B8962E;opacity:.85;margin-bottom:10px;}',
    '.kbp__title{font-family:var(--nino-serif,"Playfair Display",serif);font-size:22px;font-weight:400;color:#f5edd8;margin:0 0 6px;line-height:1.2;letter-spacing:-.01em;}',
    '.kbp__sub{font-family:var(--nino-sans,"Inter",sans-serif);font-size:12px;color:rgba(235,218,185,.55);margin:0;line-height:1.5;}',
    '.kbp__group{margin-bottom:18px;}',
    '.kbp__group-label{display:block;text-align:center;font-family:var(--nino-sans,"Inter",sans-serif);font-size:9px;font-weight:600;letter-spacing:3px;text-transform:uppercase;color:rgba(235,218,185,.42);margin-bottom:10px;}',
    '.kbp__pills{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;}',
    '.kbp__pill{padding:7px 14px;border-radius:999px;font-size:12.5px;font-family:var(--nino-sans,"Inter",sans-serif);font-weight:400;border:1px solid rgba(255,255,255,.18);background:transparent;color:rgba(235,218,185,.7);cursor:pointer;transition:all .2s ease;line-height:1;white-space:nowrap;}',
    '.kbp__pill:hover{border-color:rgba(212,175,55,.4);color:rgba(235,218,185,.92);background:rgba(212,175,55,.06);}',
    '.kbp__pill.is-active{background:linear-gradient(135deg,#d4af37,#f5e6b2);color:#000;border:none;font-weight:500;box-shadow:0 2px 10px rgba(180,148,60,.25);}',
    '.kbp__add{display:flex;align-items:center;justify-content:center;width:100%;min-height:50px;margin-top:6px;padding:14px 28px;background:linear-gradient(135deg,#d4af37,#f5e6b2);color:rgba(12,8,0,.92);font-family:var(--nino-sans,"Inter",sans-serif);font-size:12px;font-weight:600;letter-spacing:1.8px;text-transform:uppercase;border:none;border-radius:999px;cursor:pointer;transition:filter .2s ease,transform .2s ease;}',
    '.kbp__add:hover{filter:brightness(1.05);transform:translateY(-1px);}',
    '.kbp__add[disabled]{opacity:.55;cursor:not-allowed;transform:none;}',
    '.kbp__msg{margin-top:10px;font-size:12px;color:#ff8a80;text-align:center;min-height:16px;}',
    '.kbp__guarantee{text-align:center;font-family:var(--nino-sans,"Inter",sans-serif);font-size:10px;font-weight:300;color:rgba(235,218,185,.30);letter-spacing:.4px;margin:14px 0 0;}'
  ].join('');

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = STYLES;
    document.head.appendChild(s);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function ensureRoot() {
    var root = document.getElementById(ROOT_ID);
    if (root) return root;
    root = document.createElement('div');
    root.id = ROOT_ID;
    root.className = 'kbp';
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('role', 'dialog');
    root.innerHTML =
      '<div class="kbp__overlay" data-kbp-close></div>' +
      '<div class="kbp__panel" role="document">' +
        '<button type="button" class="kbp__close" data-kbp-close aria-label="Sluiten">×</button>' +
        '<div class="kbp__inner" data-kbp-inner></div>' +
      '</div>';
    document.body.appendChild(root);

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-kbp-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
    return root;
  }

  function buildInner(cfg) {
    var html = '';
    html += '<div class="kbp__head">';
    if (cfg.eyebrow) html += '<span class="kbp__eyebrow">' + escapeHtml(cfg.eyebrow) + '</span>';
    if (cfg.title)   html += '<h3 class="kbp__title">' + escapeHtml(cfg.title) + '</h3>';
    if (cfg.sub)     html += '<p class="kbp__sub">' + escapeHtml(cfg.sub) + '</p>';
    html += '</div>';

    (cfg.groups || []).forEach(function (g) {
      html += '<div class="kbp__group">';
      if (g.label) html += '<span class="kbp__group-label">' + escapeHtml(g.label) + '</span>';
      html += '<div class="kbp__pills" data-option="' + escapeHtml(g.property) + '">';
      (g.values || []).forEach(function (v, i) {
        var val = String(v).trim();
        if (!val) return;
        html += '<button type="button" class="kbp__pill' + (i === 0 ? ' is-active' : '') + '" data-value="' + escapeHtml(val) + '">' + escapeHtml(val) + '</button>';
      });
      html += '</div></div>';
    });

    html += '<button type="button" class="kbp__add" data-kbp-add>' + escapeHtml(cfg.ctaText || 'Voeg toe aan winkelwagen') + '</button>';
    html += '<div class="kbp__msg" data-kbp-msg role="alert" aria-live="polite"></div>';
    if (cfg.guarantee) html += '<p class="kbp__guarantee">' + escapeHtml(cfg.guarantee) + '</p>';
    return html;
  }

  var currentCfg = null;
  var addOriginal = '';

  function open(cfg) {
    currentCfg = cfg;
    var root = ensureRoot();
    var inner = root.querySelector('[data-kbp-inner]');
    inner.innerHTML = buildInner(cfg);

    /* Pillen group toggling */
    inner.querySelectorAll('.kbp__pills').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('.kbp__pill');
        if (!pill) return;
        group.querySelectorAll('.kbp__pill').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
      });
    });

    /* Add button */
    var addBtn = inner.querySelector('[data-kbp-add]');
    addOriginal = addBtn ? addBtn.textContent : '';
    if (addBtn) addBtn.addEventListener('click', function () { addToCart(addBtn, inner); });

    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kbp-open');
  }

  function close() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('kbp-open');
  }

  function tryOpenCart() {
    ['cart:refresh', 'cart:open', 'cart-drawer:open', 'kimaia:cart:open', 'kimaia-cart:open'].forEach(function (n) {
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: {} })); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: {} })); } catch (e) {}
    });
    if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, {}); } catch (e) {}
    }
    var icon = document.querySelector('a[href="/cart"], .cart-icon, [data-cart-toggle], #cart-icon-bubble, .header__icon--cart, [data-kimaia-cart], .kimaia-drawer-toggle');
    if (icon) setTimeout(function () { icon.click(); }, 220);
    try { document.dispatchEvent(new CustomEvent('shopify:cart:added', { bubbles: true })); } catch (e) {}
  }

  function addToCart(addBtn, inner) {
    if (!currentCfg) return;
    var properties = {};

    inner.querySelectorAll('.kbp__pills').forEach(function (g) {
      var name = g.getAttribute('data-option');
      var active = g.querySelector('.kbp__pill.is-active');
      if (name && active) properties[name] = active.getAttribute('data-value') || '';
    });

    /* Auto properties (always-included items: bottle, algae omega, etc.) */
    if (currentCfg.autoProperties) {
      Object.keys(currentCfg.autoProperties).forEach(function (k) {
        properties[k] = currentCfg.autoProperties[k];
      });
    }

    var msg = inner.querySelector('[data-kbp-msg]');
    addBtn.disabled = true;
    addBtn.textContent = 'Toevoegen…';
    if (msg) msg.textContent = '';

    var variantId = parseInt(currentCfg.variantId, 10);
    if (!variantId) {
      addBtn.disabled = false;
      addBtn.textContent = addOriginal;
      if (msg) msg.textContent = 'Bundle variant ID ontbreekt — neem contact op.';
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Toevoegen mislukt'); });
        return r.json();
      })
      .then(function () {
        addBtn.textContent = '✓ Toegevoegd!';
        tryOpenCart();
        setTimeout(function () {
          close();
          addBtn.disabled = false;
          addBtn.textContent = addOriginal;
        }, 900);
      })
      .catch(function (err) {
        addBtn.disabled = false;
        addBtn.textContent = addOriginal;
        if (msg) msg.textContent = (err && err.message) ? err.message : 'Er ging iets mis. Probeer opnieuw.';
      });
  }

  function readJsonConfig(el) {
    var raw = el.getAttribute('data-kimaia-bundle-popup-config');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { console.warn('[kbp] invalid config JSON', e); return null; }
  }

  function bindWithCfg(el, cfg) {
    if (!el || !cfg || el.__kbpBound) return;
    el.__kbpBound = true;

    /* Capture-phase listener so we run BEFORE the section's existing inline JS handler */
    el.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open(cfg);
    }, true);
  }

  function scan() {
    /* Hardcoded triggers (homepage bundles) */
    HOMEPAGE_BUNDLES.forEach(function (entry) {
      document.querySelectorAll(entry.selector).forEach(function (btn) {
        bindWithCfg(btn, entry.cfg);
      });
    });
    /* JSON-config triggers (any future cards) */
    document.querySelectorAll('[data-kimaia-bundle-popup-config]').forEach(function (btn) {
      bindWithCfg(btn, readJsonConfig(btn));
    });
  }

  function init() {
    injectStyles();
    scan();

    /* Watch for late-injected sections (e.g. theme editor preview) */
    if (window.MutationObserver) {
      new MutationObserver(function () { scan(); })
        .observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
